import * as tslib_1 from "tslib";
import { ChangeDetectionStrategy, Component } from '@angular/core';
/** An animated loading bar */
var LoadingBar = (function () {
    function LoadingBar() {
    }
    LoadingBar = tslib_1.__decorate([
        Component({
            changeDetection: ChangeDetectionStrategy.OnPush,
            selector: 'gh-loading-bar',
            styles: [require('./LoadingBar.scss')],
            template: require('./LoadingBar.pug')
        })
    ], LoadingBar);
    return LoadingBar;
}());
export { LoadingBar };



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/LoadingBar/LoadingBar.ts
// module id = 36
// module chunks = 0 1